import styled from 'styled-components';

export const RadioButton = styled.input`
  width: 16px;
  height: 16px;
`;
export const RadioText = styled.label<{
  disabled?: boolean;
  booker?: boolean;
  segment?: boolean;
}>`
  font-weight: 400;
  margin-left: ${({ booker, segment }) => (booker || segment ? '0px' : '10px')};
  cursor: ${({ disabled }) => (disabled ? 'revert' : 'pointer')};
  &span {
    font-size: 14px;
  }
  display: grid;
  grid-template-columns: ${({ segment }) =>
    segment ? ` 10px 1fr` : ` 16px 1fr`};
  gap: 10px;
  align-items: center;
  color: ${({ theme, segment }) =>
    segment ? theme.palette.white : theme.palette.darkGray};
`;

export const RadioWrapper = styled.label`
  align-items: center;
  display: flex;
`;
export const RadioContainer = styled.div<{
  disabled?: boolean;
  segment?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  input[type='radio']:not(old) {
    display: inline-block;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border-radius: 1em;
    background-color: ${({ theme, segment }) =>
      segment ? theme.palette.transparent2 : theme.palette.white};
    border: ${({ theme, segment }) =>
      segment
        ? `2px solid ${theme.palette.white}`
        : `1px solid ${theme.palette.gray87}`};
  }
  input[type='radio']:not(old):hover {
    border: ${({ segment }) => (segment ? 2 : 1)}px solid
      ${({ disabled, theme, segment }) =>
        segment || disabled ? theme.palette.gray87 : theme.palette.darkGray};
  }

  input[type='radio']:not(old):checked {
    border: ${({ segment, theme }) =>
      segment
        ? `2px solid ${theme.palette.white}`
        : `2px solid ${theme.palette.darkGray}`};
    background-image: radial-gradient(
      circle at center,
      ${(p) =>
        p.segment ? p.theme.palette.white : p.theme.palette.burntSienna},
      ${(p) =>
          p.segment ? p.theme.palette.white : p.theme.palette.burntSienna}
        37.5%,
      ${(p) =>
          p.segment ? p.theme.palette.transparent2 : p.theme.palette.white}
        40%,
      ${(p) =>
          p.segment ? p.theme.palette.transparent2 : p.theme.palette.white}
        100%
    );
  }
`;
